import React from 'react';
import {
  Box,
  Typography,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { motion } from 'framer-motion';
import repuestosImg from '../../static/media/home/repuestos.webp';

const items = [
  {
    title: 'Recuperación profesional de datos personales:',
    description:
      'Recuperamos tu información más valiosa desde discos duros, memorias, equipos dañados o formateados con herramientas especializadas.',
  },
  {
    title: 'Acompañamiento en compras tecnológicas:',
    description:
      'Te asesoramos para elegir la mejor laptop, impresora, cámara o accesorio según tus necesidades personales o profesionales.',
  },
  {
    title: 'Desarrollo de páginas web personalizadas:',
    description:
      'Creamos sitios funcionales y modernos con tecnologías como Django, React y Flutter. Ideal para negocios, tiendas y proyectos personales.',
  },
  {
    title: 'Soporte técnico y seguimiento postventa:',
    description:
      'Nuestro compromiso continúa después de la compra. Brindamos soporte técnico, revisiones, mantenimiento y seguimiento personalizado.',
  },
];

const fadeVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: (i = 1) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.25, duration: 0.6 },
  }),
};

const ProfessionalTraining = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: 'center',
        justifyContent: 'center',
        gap: 6,
        px: 4,
        py: 8,
        background: 'linear-gradient(90deg, #333 0%, #000 50%, #333 100%)',
      }}
    >
      <motion.div
        initial={{ opacity: 0, x: -60 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true, amount: 0.3 }}
        style={{ width: '100%', maxWidth: 480 }}
      >
        <Box
          component="img"
          src={repuestosImg}
          alt="Servicios tecnológicos"
          sx={{
            width: '100%',
            height: { xs: 'auto', md: 280 },
            borderRadius: '16px',
            objectFit: 'cover',
            maxHeight: { xs: 220, sm: 260, md: 280 },
          }}
        />
      </motion.div>

      <Box sx={{ width: { xs: '100%', md: '55%' }, color: '#4e2600' }}>
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true, amount: 0.4 }}
        >
          <Typography
            component="h2"
            sx={{
              fontWeight: 'bold',
              mb: 3,
              fontSize: { xs: '1.6rem', sm: '1.8rem', md: '2.2rem' },
              color: '#fff',
            }}
          >
            Soluciones digitales y soporte tecnológico
          </Typography>
        </motion.div>

        <List>
          {items.map((item, index) => (
            <ListItem
              key={index}
              disableGutters
              sx={{ alignItems: 'flex-start' }}
              component={motion.li}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
              variants={fadeVariants}
              custom={index + 1}
            >
              <ListItemIcon sx={{ mt: 0.5, color: '#fff' }}>
                <CheckCircleIcon />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Typography component="span" fontWeight="bold" color="#fff">
                    {item.title}
                  </Typography>
                }
                secondary={item.description}
                secondaryTypographyProps={{ color: '#fff' }}
              />
            </ListItem>
          ))}
        </List>

        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.4, duration: 0.5 }}
          viewport={{ once: true, amount: 0.2 }}
        >
          <Box sx={{ display: 'flex', gap: 3, mt: 4, flexWrap: 'wrap' }}>
            <Button
              component="a"
              href="/contacto"
              variant="contained"
              sx={{
                bgcolor: '#fff',
                color: '#000',
                fontWeight: 'bold',
                px: 4,
                py: 1.5,
                '&:hover': {color: '#333', },
              }}
            >
              CONTÁCTANOS
            </Button>

            <Button
              component="a"
              href="/categorias"
              variant="outlined"
              sx={{
                borderColor: '#fff',
                color: '#fff',
                fontWeight: 'bold',
                px: 4,
                py: 1.5,
                fontSize: { xs: '0.8rem', sm: '0.9rem', lg: '1rem' },
                '&:hover': {
                  bgcolor: '#fff',
                  color: '#000',
                },
              }}
            >
              VER PRODUCTOS
            </Button>
          </Box>
        </motion.div>
      </Box>
    </Box>
  );
};

export default ProfessionalTraining;
